import { styled } from "@mui/system";

const Container = styled("div")(
  ({
    theme,
    halfGap,
    topped,
    halfBottom,
    fullHeight,
    align,
    noJustify,
    end,
    start,
    center,
    noGap,
    minGap,
    doubleGap,
    small,
    padding,
  }) => ({
    display: "flex",
    flexFlow: "column",
    height: `${fullHeight ? "100%" : "auto"}`,
    marginBottom: `${halfBottom ? theme.space.half : 0}`,
    marginTop: `${topped ? theme.space.double : 0}`,
    padding: `${padding ? padding : 0}`,
    gap: `${
      halfGap
        ? theme.space.main
        : doubleGap
        ? theme.space.triple
        : noGap
        ? "0"
        : minGap
        ? theme.space.main
        : theme.space.double
    }`,
    justifyContent: `${
      noJustify
        ? "initial"
        : center
        ? "center"
        : end
        ? "flex-end"
        : start
        ? "flex-start"
        : "space-between"
    }`,
    alignItems: `${
      align === "end"
        ? "flex-end"
        : align === "start"
        ? "flex-start"
        : align === "center"
        ? "center"
        : "stretch"
    }`,
  })
);

const ColumnContainer = ({ children, className, ...props }) => {
  return (
    <Container className={className} {...props}>
      {children}
    </Container>
  );
};

export const StyledPaddingColumnContainer = styled(ColumnContainer)`
  padding: 0px 50px 0px;
  gap: 1rem;
  @media screen and (max-width: 676px) {
    padding: 0px;
  }
  @media screen and (min-width: 1200px) {
    padding: 0px 60px 0px;
  }
`;

export default ColumnContainer;
